import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`An optional `}<inlineCode parentName="p">{`name`}</inlineCode>{` attribute for the input element wrapped by `}<inlineCode parentName="p">{`CvvInput`}</inlineCode>{`.`}</p>
    <p>{`The name you provide will always be prefixed with `}<inlineCode parentName="p">{`cvv-`}</inlineCode>{`, so if for example you pass `}<inlineCode parentName="p">{`name: 'custom'`}</inlineCode>{` the `}<inlineCode parentName="p">{`CVVInput`}</inlineCode>{` will wrap an `}<inlineCode parentName="p">{`HTMLInputElement`}</inlineCode>{` that looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`<input name='cvv-custom' /* Other attributes */ />
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      